<template>
<div class="d-flex menu-item p-2 noselect" :class="{ selected: selected}" :style="{ '--border-color' : circleColor}" @click="$emit('clicked', indexInList)">
  <AvatarImage :userId="item.uuid"/>

  <div class="ml-auto p-2 list-text menu-item-text">{{item.first_name}} {{item.last_name}}</div>
  <span class="item-desc">{{timeDiff(item.test_created_at)}}</span>
  <!--<SidebarMenuBadge class="p-2 list-badge"/>-->
</div>
</template>

<script>
import AvatarImage from '@/components/AvatarImage.vue'
import SidebarMenuBadge from '@/components/SidebarMenuBadge.vue'
import {timeDifference} from '@/_helpers'

export default {
  components: {
    SidebarMenuBadge,
    AvatarImage
  },
  props: {
    circleColor: String,
    item: Object,
    selected: Boolean,
    indexInList: -1
  },
  methods: {
    timeDiff (time) {
      return timeDifference(time, this.$t)
    }
  },
  computed: {
  },
  created () {
  }
}
</script>

<style>
.user-status {
  position:absolute;
  bottom: 0;
  left: 0;
}
.menu-item .profile-image {
  width: 48px;
  height: 48px;
}
.menu-item.selected {
  background-color: var(--sidebar-selected-background-color);
  color: var(--sidebar-selected-text-color);
  border-radius: 2px;
}
.menu-item {
  position: relative;
  transition: all 0.2s;
  /* border-right: 3px solid; */
}
.menu-item-text {
  color: var(--sidebar-text-color);
}
.item-desc {
  color: var(--sidebar-desc-text-color);
  font-size: smaller;
}
.menu-item.selected .item-desc {
  color: var(--sidebar-selected-desc-text-color);
}

.menu-item:before {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 4px;
    border-radius: 4px 0 0 4px;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
    height: 80%;
    background: var(--border-color);
}

</style>



// WEBPACK FOOTER //
// src/components/SidebarMenuItem.vue